import { Directive, ElementRef, HostListener, Input ,Renderer2} from '@angular/core';

@Directive({
  selector: '[appMouseactions]'
})
export class MouseactionsDirective {
  @Input() tooltip: string;
  constructor(private elRef: ElementRef,private renderer: Renderer2) { }
  @HostListener('mouseover',["$event"]) onMouseOver(target) {
    this.addAndRemoveToolTips('append',target);
  }
  @HostListener('mouseleave',["$event"]) onMouseLeave(target) {
    this.addAndRemoveToolTips('',target);
  }
  @HostListener('mouseup',["$event"]) onmouseup(target){
    this.addAndRemoveToolTips('',target);
  }
  private addAndRemoveToolTips(state: string,ev) {
    let element = document.createElement('span');
    element.className = 'dynamicToolTip'

    if(state == 'append'){
      document.getElementsByTagName('body')[0].appendChild(element)
      this.displayTooltip(ev)
    }
    else{
      if(document.getElementsByClassName('dynamicToolTip')[0]){
        for(var i = 0;i <= document.getElementsByClassName('dynamicToolTip').length;i++){
          document.getElementsByClassName('dynamicToolTip')[0].remove();
        }
      }     
    }
  }

  displayTooltip(ev){
    let dynamicToolTip = document.getElementsByClassName('dynamicToolTip')[0];
    dynamicToolTip.textContent = this.tooltip;
    let currentEle = this.elRef.nativeElement;
    // dynamicToolTip['style'].top = (ev.pageY + currentEle.offsetHeight + 10) +'px';
    // dynamicToolTip['style'].left = (ev.pageX - (dynamicToolTip['offsetWidth']/2) + (currentEle.offsetWidth/2)) +'px';
    
    dynamicToolTip['style'].top = (currentEle.getBoundingClientRect().top + currentEle.offsetHeight + 10) +'px';
    dynamicToolTip['style'].left = (currentEle.getBoundingClientRect().left - (dynamicToolTip['offsetWidth']/2) + (currentEle.offsetWidth/2)) +'px';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/mouseactions.directive.ts